/* localStorage helpers that never throw — private mode, quota, disabled
   storage all degrade to "seed data only" instead of breaking the app. */

export function readJSON<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (raw == null) return fallback;
    const parsed = JSON.parse(raw) as T;
    return parsed ?? fallback;
  } catch {
    return fallback;
  }
}

/** @returns true when the value was persisted. */
export function writeJSON(key: string, value: unknown): boolean {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    remove(key);
    return false;
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(key);
  } catch {
    /* storage unavailable */
  }
}

export function readString(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeString(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* storage unavailable */
  }
}

/** Every stored key that starts with `prefix`, paired with its suffix. */
export function keysWithPrefix(prefix: string): { key: string; suffix: string }[] {
  const out: { key: string; suffix: string }[] = [];
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (!key || !key.startsWith(prefix)) continue;
      out.push({ key, suffix: key.slice(prefix.length) });
    }
  } catch {
    /* storage unavailable */
  }
  return out;
}
